import config from '@/config'

export default {
  combine: {
    confirm_password: "@:ui.password নিশ্চিত করুন",
    change_password: "@:ui.password পরিবর্তন করুন",
    old_password: "পুরাতন @:ui.password",
    new_password: "@:ui.new @:ui.password",
    confirm_security_code: "@:ui.security_code নিশ্চিত করুন",
    first_time_login: "প্রথমবার লগইন করুন",
    security_authentication: "সিকিউরিটি অথেনটিকেশন",
    update_security: "নিরাপত্তা আপডেট করুন",
    disable_security: "নিরাপত্তা নিষ্ক্রিয় করুন",
    add_account: "অ্যাকাউন্ট যোগ করুন",
    add_sub_account: "সাব অ্যাকাউন্ট যুক্ত করুন",
    edit_operator: "অপারেটর সম্পাদনা করুন",
    edit_account: "অ্যাকাউন্ট সম্পাদনা করুন",
    edit_member: "এডিট মেম্বার",
    approve_ticket: "টিকিট অনুমোদন করুন",
    reject_ticket: "টিকিট প্রত্যাখ্যান করুন",
    add_bank_account: "ব্যাংক অ্যাকাউন্ট যোগ করুন",
    edit_bank_account: "ব্যাংক অ্যাকাউন্ট সম্পাদনা করুন",
    reset_threshold: "রিসেট থ্রেশহোল্ড",
    adjust_balance: "অ্যাডজাস্ট ব্যালেন্স",
    adjust_member: "অ্যাডজাস্ট মেম্বার",
    configure_bank_setting: "ব্যাংক সেটিং কনফিগার করুন",
    account_setup: "অ্যাকাউন্ট সেটআপ",
    bank_transfer: "ব্যাংক ট্রান্সফার",
    edit_bank_member: "ব্যাংক সদস্য সম্পাদনা করুন",
    edit_ticket: "টিকিট সম্পাদনা করুন",
    edit_vip: "ভিআইপি সম্পাদনা করুন",
    knock_off_promo: "নক অফ প্রচার",
    edit_authority: "সম্পাদনা কর্তৃপক্ষ",
    reset_password: "পাসওয়ার্ড রিসেট করুন",
    update_password: "পাসওয়ার্ড আপডেট করুন",
    member_summary: "সদস্যের সারসংক্ষেপ",
    reply_review: "রিপ্লাই রিভিউ",
    edit_affiliate : "এডিট এজেন্ট",
    edit_bank_affiliate : "ব্যাংক এজেন্ট সম্পাদনা করুন",
    approve_affiliate_ticket: "এজেন্ট টিকিট অনুমোদন করুন",
    check_free_spin: "ফ্রি স্পিন চেক করুন",
    reject_affiliate_ticket: "এজেন্ট টিকিট প্রত্যাখ্যান করুন",
    wallet_adjust: "ওয়ালেট অ্যাডজাস্ট",
    update_comm_package: "যোগাযোগ প্যাকেজ আপডেট করুন",
    approve_affiliate : "এজেন্ট অনুমোদন করুন",
    sub_acc_detail_affiliate : "সাব অ্যাকাউন্ট ডিটেইল এজেন্ট",
    get_tac: "ওটিপি পান",
    add_coupon: "কুপন যোগ করুন",
    update_coupon: "কুপন আপডেট করুন",
    issue_free_spin: "ফ্রি স্পিন ইস্যু করুন",
    get_bank_tac: "ব্যাংক ওটিপি পান",
    update_global_setting: "গ্লোবাল সেটিং আপডেট করুন",
    add_platform: "প্ল্যাটফর্ম যুক্ত করুন",
    edit_platform: "প্ল্যাটফর্ম সম্পাদনা করুন",
    add_bank_group: "ব্যাংক গ্রুপ যোগ করুন",
    edit_bank_group: "ব্যাংক গ্রুপ সম্পাদনা করুন",
    update_maintenance_schedule: "রক্ষণাবেক্ষণের সময়সূচী আপডেট করুন",
    add_withdrawal_limit: "প্রত্যাহারের সীমা যোগ করুন",
    edit_withdrawal_limit: "প্রত্যাহারের সীমা সম্পাদনা করুন",
    add_campaign: "প্রচারাভিযান যোগ করুন",
    edit_campaign: "সম্পাদনা প্রচারাভিযান",
    add_promo_group: "প্রচার গ্রুপ যুক্ত করুন",
    edit_promo_group: "প্রচার গ্রুপ সম্পাদনা করুন",
    update_team: "টিম আপডেট করুন",
    update_result: "ফলাফল আপডেট করুন",
    insert_result: "ফলাফল সন্নিবেশ করুন",
    bet_list: "বাজি তালিকা",
    result_list: "ফলাফল তালিকা",
    add_promo: "প্রচার যোগ করুন",
    raise_deposit_ticket: "ডিপোজিট টিকিট বাড়ান",
    bank_adjust: "ব্যাংক অ্যাডজাস্ট",
    promo_member_assign: "পদোন্নতি সদস্য নিয়োগ করুন",
    bonus_issue: "বোনাস ইস্যু",
    update_vip: "ভিআইপি আপডেট করুন",
    update_member_profile: "সদস্য প্রোফাইল আপডেট করুন",
    change_withdrawal_limit: "প্রত্যাহারের সীমা পরিবর্তন করুন",
    change_bank_group: "ব্যাংক গ্রুপ পরিবর্তন করুন",
    change_promotion_group: "প্রচার গ্রুপ পরিবর্তন করুন",
    edit_promo_signup: "প্রচার সাইনআপ সম্পাদনা করুন",
    update_provider_bet_limit: "আপডেট সরবরাহকারীর বাজি সীমা",
    update_bet_limit: "বাজি সীমা আপডেট করুন",
    update_member_bet_limit: "সদস্য বাজি সীমা আপডেট করুন",
    edit_bank_account_group: "ব্যাংক অ্যাকাউন্ট গ্রুপ সম্পাদনা করুন",
    redeposit_ticket: "টিকিট পুনরায় জমা করুন",
    edit_promotion_group: "প্রচার গ্রুপ সম্পাদনা করুন",
    edit_promotion_group_norm: "গ্রুপে প্রচার পরিচালনা করুন",
    get_inbox_list: "ইনবক্স তালিকা পান",
    view_result_changes_detail: "ফলাফল পরিবর্তনের বিশদ দেখুন",
    edit_promotion_signup: "প্রচার সাইনআপ সম্পাদনা করুন",
    edit_bet_limit: "বাজি সীমা সম্পাদনা করুন",
    edit_provider_game_off: "সরবরাহকারীর গেম বন্ধ সম্পাদনা করুন",
    edit_provider_rtp: "সরবরাহকারী আরটিপি সম্পাদনা করুন",
    get_rebate: "ছাড় পান",
    get_recent_deposit: "সাম্প্রতিক আমানত পান",
    add_survey: "সমীক্ষা যোগ করুন",
    add_announcement_banner: "ঘোষণার ব্যানার যুক্ত করুন",
    edit_announcement_banner: "ঘোষণা ব্যানার সম্পাদনা করুন",
    move_announcement_banner: "ঘোষণার ব্যানার সরান",
    add_promotion_banner: "প্রচার ব্যানার যোগ করুন",
    edit_promotion_banner: "প্রচার ব্যানার সম্পাদনা করুন",
    unlink_banner: "আনলিঙ্ক করুন",
    move_promotion_banner: "প্রচার ব্যানার সরান",
    add_slide_banner: "স্লাইড ব্যানার যুক্ত করুন",
    edit_slide_banner: "স্লাইড ব্যানার সম্পাদনা করুন",
    move_slide_banner: "স্লাইড ব্যানার সরান",
    add_seo_page: "এসইও পৃষ্ঠা যুক্ত করুন",
    edit_seo_page: "এসইও পৃষ্ঠা সম্পাদনা করুন",
    clear_outstanding: "ক্লিয়ার আউটস্ট্যান্ডিং",
    add_ip_whitelist: "আইপি হোয়াইটলিস্ট যুক্ত করুন",
    bonus_issue_bulk: "বাল্ক বোনাস ইস্যু",
    edit_bank_member_ewallet: "ব্যাংক সদস্য সম্পাদনা করুন (ই-ওয়ালেট)",
    redeposit: "রিডিপোজিট",
    reject_approved_ticket: "অনুমোদিত টিকিট প্রত্যাখ্যান করুন",
    audit_ticket: "অডিট টিকিট",
    review_ticket: "রিভিউ টিকিট",
    edit_promotion_group_norm_seq: "গ্রুপে প্রচার ক্রম পরিচালনা করুন",
    edit_promo_provider_list: "প্রচার সরবরাহকারীর তালিকা সম্পাদনা করুন",
    edit_promo_payment_option: "প্রচার পেমেন্ট বিকল্প সম্পাদনা করুন",
    edit_campaign_provider_list: "প্রচারাভিযান সরবরাহকারীর তালিকা সম্পাদনা করুন",
    update_comm: "কমিশন আপডেট করুন",
    update_carry_over: "আপডেট ক্যারি ওভার",
    review_affiliate_ticket: "রিভিউ এজেন্ট টিকিট",
    audit_affiliate_ticket: "অডিট এজেন্ট টিকিট",
    get_tac_affiliate : "ওটিপি (এজেন্ট) পান",
    raise_deposit_ticket_gateway: "রেইজ ডিপোজিট টিকিট (গেটওয়ে)",
    direct_audit_ticket: "অডিট টিকিট (সরাসরি)",
    get_rollback_detail: "রোলব্যাক বিশদ পান",
    get_reject_detail: "প্রত্যাখ্যান বিশদ পান",
    manual_approve_ticket: "টিকিট অনুমোদন করুন (ম্যানুয়াল)",
    add_label: "লেবেল যোগ করুন",
    edit_label: "লেবেল সম্পাদনা করুন",
    rollback_processing_ticket: "রোলব্যাক প্রসেসিং টিকিট",
    update_iframe_url: "আইফ্রেম ইউআরএল আপডেট করুন",
    edit_exchange_rate: "বিনিময় হার সম্পাদনা করুন",
    add_vip: "ভিআইপি যোগ করুন",
    add_turnover_tier: "টার্নওভার স্তর যুক্ত করুন",
    edit_turnover_tier: "টার্নওভার স্তর সম্পাদনা করুন",
    edit_mission_reward: "মিশন পুরস্কার সম্পাদনা করুন",
    enable_mission_reward: "মিশন পুরস্কার সক্রিয় করুন",
    get_member_label_list: "সদস্য লেবেল তালিকা",
    add_rescue_fund: "উদ্ধার তহবিল যুক্ত করুন",
    get_custom_member_list: "কাস্টম সদস্য তালিকা",
    get_rescue_fund_provider: "উদ্ধার তহবিল সরবরাহকারী পান",
    add_game_exclude: "গেম এক্সক্লুড যোগ করুন",
    delete_game_exclude: "গেম এক্সক্লুড মুছুন",
    domain_custom_add_assign: "ডোমেইন যুক্ত করুন",
    add_domain_batch: "ডোমেন (ব্যাচ) যুক্ত করুন",
    update_payment_provider_vip: "পেমেন্ট প্রোভাইডার ভিআইপি আপডেট করুন",
    update_campaign: "ক্যাম্পেইন আপডেট করুন",
    purchase_domain: "ডোমেন ক্রয় করুন",
    apply_domain: "ডোমেন প্রয়োগ করুন",
    edit_access_control: "অ্যাক্সেস কন্ট্রোল সম্পাদনা করুন",
    add_domain: "ডোমেইন যোগ করুন",
    operator_wallet_adjust: "অপারেটর ওয়ালেট অ্যাডজাস্ট করুন",
    update_payment_provider_desc: "পেমেন্ট সরবরাহকারীর বিবরণ আপডেট করুন",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "সেটআপ লোগো",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "সরবরাহকারী পিটি অপারেটর আপডেট",
    provider_pt_global_update: "সরবরাহকারী পিটি গ্লোবাল আপডেট",
    payment_option_callback_update: "কলব্যাক ইউআরএল আপডেট",
    change_payment_option_seq: "পেমেন্ট অপশন সিকোয়েন্স",
    change_payment_mode_status: "পেমেন্ট অপশন স্ট্যাটাস আপডেট",
    change_payment_option_recommend: "পেমেন্ট অপশন সুপারিশ",
    change_payment_option_credential: "পেমেন্ট অপশন ক্রেডেনশিয়াল",
    change_payment_option_limit: "পেমেন্ট অপশন লিমিট",
    change_payment_option_vip: "পেমেন্ট অপশন ভিআইপি",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
    add_leaderboard: "@:ui.add @:ui.leaderboard",
    edit_leaderboard: "@:ui.edit @:ui.leaderboard",
    add_phone: "@:ui.add @:ui.phone",
    adjust_free_balance: "ফ্রি ব্যালান্স সমন্বয় করুন",
    edit_ai_assistant: "@:ui.edit @:ui.ai_assistant",
    change_payment_option_desc: "পেমেন্ট অপশনের বিবরণ",
    fund_transfer_provider: "ফান্ড ট্রান্সফার প্রদানকারী",
    manual_deposit: "ম্যানুয়াল ডিপোজিট",
    change_linkage_desc: "লিংকেজ বর্ণনা",
    change_linkage_risk_weight: "লিংকেজ ঝুঁকি ওজন",
    add_promo_voucher: "@:ui.add @:ui.promotion_voucher",
    edit_promotion_voucher_end_date: "@:ui.edit @:ui.promotion_voucher @:ui.end_date",
    get_voucher_custom_member_list: "ভাউচার কাস্টম সদস্য তালিকা পান",
    redeposit_ticket_voucher: "টিকিট ভাউচার পুনরায় জমা",
    approve_ticket_voucher: "টিকিট ভাউচার অনুমোদন",
    reject_ticket_voucher: "টিকিট ভাউচার প্রত্যাখ্যান",
    raise_deposit_ticket_voucher: "ডিপোজিট টিকিট ভাউচার তৈরি",
    raise_deposit_ticket_voucher_gateway: "ডিপোজিট টিকিট ভাউচার গেটওয়ে তৈরি",
    get_voucher_list: "ভাউচার তালিকা পান",
    get_message_list: "বার্তা তালিকা পান",
    edit_free_credit: "@:ui.edit @:ui.free_credit",
    knock_off_free_credit_member: "ফ্রি ক্রেডিট সদস্য বাতিল",
    free_credit_manual_assign: "ফ্রি ক্রেডিট ম্যানুয়াল অ্যাসাইন",
    review_fcp_ticket: "ফ্রি ক্রেডিট প্রদানকারী টিকিট পর্যালোচনা",
    audit_fcp_ticket: "ফ্রি ক্রেডিট প্রদানকারী টিকিট অডিট",
    reject_fcp_ticket: "ফ্রি ক্রেডিট প্রদানকারী টিকিট প্রত্যাখ্যান",
    approve_fcp_ticket: "ফ্রি ক্রেডিট প্রদানকারী টিকিট অনুমোদন",
    edit_trigger: "ট্রিগার সম্পাদনা",
    edit_trigger_status: "ট্রিগার স্ট্যাটাস সম্পাদনা",
    adjust_voucher_balance: "ভাউচার ব্যালেন্স সমন্বয় করুন",
    clear_free_credit: "ফ্রি ক্রেডিট পরিষ্কার করুন",
    add_deposit_tier: "ডিপোজিট স্তর যোগ করুন",
    edit_deposit_tier: "ডিপোজিট স্তর সম্পাদনা করুন",
    add_leaderboard_banner: "লিডারবোর্ড ব্যানার যোগ করুন",
    edit_leaderboard_banner: "লিডারবোর্ড ব্যানার সম্পাদনা করুন",
    add_referral_banner: "রেফারেল ব্যানার যোগ করুন",
    edit_referral_banner: "রেফারেল ব্যানার সম্পাদনা করুন",
    edit_vip_icon: "VIP আইকন সম্পাদনা",
    add_reward_rain: "Reward Rain যোগ করুন",
    edit_reward_rain: "Reward Rain সম্পাদনা করুন",
    add_reward_rain_session: "Reward Rain সেশন যোগ করুন",
    edit_reward_rain_session: "Reward Rain সেশন সম্পাদনা করুন",
    edit_reward_rain_session_end_date: "Reward Rain সেশনের শেষ তারিখ সম্পাদনা করুন",
    add_news: "সংবাদ যোগ করুন",
    edit_news: "সংবাদ সম্পাদনা করুন",
  },
  short: {
    deposit_amount: "ডেপ অ্যামট",
    base_amount: "বেস অ্যামট",
    bonus_amount: "বোনাস অ্যামট",
    target_amount: "Trgt Amt",
    knockoff_by: "K.O দ্বারা",
    knockoff_date: "কে.ও. তারিখ",
    incoming_threshold: "ইন থ্রেস",
    incoming_frequency: "ফ্রিকোয়েন্সে",
    outgoing_threshold: "আউট থ্রেস",
    outgoing_frequency: "আউট ফ্রিকিউ",
    account_balance: "দুদক বিএএল",
    claim_type: "সি.টাইপ",
    bonus_rate: "বি.রেট",
    max_bonus: "এম.বোনাস",
    rollover: "রোলওভার",
    criteria: "মানদণ্ড",
    start_time: "এস.টাইম",
    end_time: "ই.টাইম",
    monday: "সোম",
    tuesday: "মঙ্গলবার",
    wednesday: "ওয়েড",
    thursday: "থু",
    friday: "ফ্রাই",
    saturday: "স্যাট",
    sunday: "সূর্য",
    status: "স্ট্যাটাস",
    bonus_rate_percent: "বি.রেট (%)",
    valid_turnover: "ভি.টার্নওভার",
    deposit_count: "ডেপ সিএনটি",
    withdrawal_amount: "ডাব্লুডিডাব্লু অ্যামট",
    withdrawal_count: "ডাব্লুডিডাব্লু সিএনটি",
    adjustment_amount: "অ্যাডজ অ্যামট",
    referee_count: "রেফারি সিএনটি",
    signup_count: "সাইনআপ সিএনটি",
    verified_count: "ভিআরএফ গণনা",
    active_member: "অ্যাক্টিভ এমবিএম",
    ftd_count: "এফটিডি সিএনটি",
    ftd_amount: "এফটিডি অ্যামট",
    working_date: "ওয়ার্কিং ডিটি",
    recipient_bank_id: "আর.ব্যাংক আইডি",
    recipient_bank_acc_no: "আর.ব্যাংক এসিসি নং",
    recipient_bank_acc_holder: "আর.ব্যাঙ্ক অ্যাকাউন্ট হোল্ডার",
    sender_bank: "এস.ব্যাংক",
    sender_bank_acc_no: "এস.ব্যাংক অ্যাকাউন্ট নং",
    sender_bank_acc_holder: "এস.ব্যাঙ্ক অ্যাকাউন্ট হোল্ডার",
    unique_login_count: "ইউ.লগইন সিএনটি",
    unique_deposit_count: "ইউ.ডি.ই.পি. সি.এন.টি",
    unique_withdrawal_count: "ইউ.ডব্লিউ.ডি.ডাব্লু সি.এন.টি",
    second_deposit_count: "এস.ডি.ই.পি. সি.এন.টি",
    reject_date: "আর.ডেট",
    processing_date: "পি.ডেট",
    deposit_withdrawal_different: "ডেপ ডাব্লুডিডাব্লু ডিফ",
    external_id: "প্রাক্তন আইডি",
    draft_version: "খসড়া। Ver.",
    prod_version: "প্রোড. ভার্.",
    purchased_date: "পি. তারিখ",
    completed_amount: "কমপ্লাই অ্যামট",
    min_amount: "ন্যূনতম পরিমাণ",
    max_amount: "সর্বোচ্চ পরিমাণ",
    total_claimed_amount: "মোট দাবি করা পরিমাণ",
  },
  date_ranges: {
    0: "'আজ",
    1: "'গতকাল",
    2: "'এই মাসে",
    4: "গত মাস"
  },
  langList: {
    EN: "ইংরেজী",
    CN: "চাইনিজ",
    PHP: "ফিলিপাইন",
    esp: "স্প্যানিওল",
    RUS: "রাশিয়ান'",
    VI: "ভিয়েতনামিজ",
    MS: "মালয়",
    NE: "নেপালি",
    CT: "চীনা (তাইওয়ান)",
    BN: "বাংলা"
  },
  menulist: {
    home: "বাড়ি",
    hot: "গরম",
    slot_game: "স্লট",
    casino: "ক্যাসিনো",
    sportsbook: "খেলাধুলা",
    fishing: "মাছ ধরা",
    lottery: "লটারি",
    poker: "জুজু",
    hash_game: "হ্যাশ গেম",
    sabong: "সাবং",
    promotion: "প্রচার",
    review: "রিভিউ",
    news: "সংবাদ",
    live_stream: "লাইভ স্ট্রিম",
    vip: "ভিআইপি",
    referral: "রেফারেল",
    favourite: "প্রিয়",
    mission: "মিশন (মিনি গেম)",
    spin: "স্পিন",
    leaderboard: "লিডারবোর্ড",
    account: "অ্যাকাউন্ট",
    deposit: "ডিপোজিট",
    withdrawal: "প্রত্যাহার",
    bet_history: "বাজি ইতিহাস",
    pending_status: "মুলতুবি স্থিতি",
    change_password: "@:ui.password পরিবর্তন করুন",
    profile: "প্রোফাইল",
    banking_details: "ব্যাংকিং বিবরণ",
    inbox: "ইনবক্স",
    voucher: "ভাউচার",
    wallet: "মানিব্যাগ",
    statement: "বিবৃতি",
    download: "ডাউনলোড",
    game: "খেলা",
    special: "বিশেষ",
    misc: "বিবিধ",
    contact_us: "আমাদের সাথে যোগাযোগ করুন",
    e_sportsbook: "ই-স্পোর্টসবুক",
    lotto: "লোটো",
    p2p: "পি 2 পি",
    other: "অন্যান্য",
    vip2: "ভিআইপি 2",
    referral2: "রেফারেল 2",
    event: "ইভেন্ট",
    daily_reward: "দৈনিক পুরষ্কার",
    play2earn: "প্লে 2 উপার্জন",
    redemption: "মুক্তি",
    card_board: "কার্ড বোর্ড",
    lobby: "লবি",
    in_house: "ইন হাউজ",
    transfer: "স্থানান্তর",
    horse_racing: "ঘোড়া দৌড়",
    register: "নিবন্ধন",
    login: "লগইন",
    transaction_history: "লেনদেনের ইতিহাস",
    bingo: "বিঙ্গো",
    member: "সদস্য",
    arcade: "আর্কেড",
    crash: "ক্র্যাশ",
    freeplay: "ফ্রি প্লে",
    others: "অন্যান্য",
  },

  ok: "ঠিক আছে",
  cancel: "বাতিল",
  login: "লগইন",
  logout: "লগআউট",
  add: "যোগ করুন",
  edit: "সম্পাদনা",
  delete: "মুছে ফেলুন",
  refresh: "রিফ্রেশ",
  action: "অ্যাকশন",
  id: "আইডি",
  name: "নাম",
  all: "সব",
  search: "অনুসন্ধান",
  remove: "অপসারণ করুন",
  save: "সংরক্ষণ করুন",
  account: "অ্যাকাউন্ট",
  settings: "সেটিংস",
  on: "অন",
  off: "বন্ধ",
  new: "নতুন",
  clear: "পরিষ্কার",
  users: "ব্যবহারকারী | ব্যবহারকারী",
  username: "ব্যবহারকারীর নাম",
  password: "পাসওয়ার্ড",
  created_on: "ক্রিয়েট অন",
  active: "সক্রিয়",
  page_size: "পৃষ্ঠার আকার",
  status: "স্ট্যাটাস",
  result: "ফলাফল",
  close: "ক্লোজ",
  back: "পিছনে",
  show: "দেখান",
  login_id: "লগইন আইডি",
  date_time: "ডেটটাইম",
  ip_address: "আইপি ঠিকানা",
  domain_name: "ডোমেইন নাম",
  browser_agent: "ব্রাউজার এজেন্ট",
  action_by: "অ্যাকশন বাই",
  details: "বিস্তারিত",
  key: "কী | চাবি",
  value: "মূল্য | মূল্যবোধ",
  from: "থেকে",
  to: "টু",
  type: "টাইপ",
  criteria: "মানদণ্ড",
  log: "লগ",
  report: "রিপোর্ট",
  security_tag: "সিকিউরিটি ট্যাগ",
  security_code: "সিকিউরিটি কোড",
  submit: "জমা দিন",
  disable: "নিষ্ক্রিয় করুন",
  operators: "অপারেটর | অপারেটর",
  members: "সদস্যরা",
  account_id: "অ্যাকাউন্ট আইডি",
  confirm_password: "@:ui.password নিশ্চিত করুন",
  full_name: "পুরো নাম",
  contact_phone: "যোগাযোগ ফোন",
  contact_email: "যোগাযোগের ইমেল",
  dashboard: "ড্যাশবোর্ড",
  sub_account: "সাব অ্যাকাউন্ট",
  authority_option: "কর্তৃপক্ষের বিকল্প",
  banks: "ব্যাংক | ব্যাংক",
  login_ip : "লগইন আইপি",
  block: "ব্লক",
  profile_id: "প্রোফাইল আইডি",
  suspend: "সাসপেন্ড",
  deposit: "ডিপোজিট",
  withdrawal: "প্রত্যাহার",
  bulk_withdrawal: "থোক প্রত্যাহার",
  rejected: "প্রত্যাখ্যান",
  processed: "প্রক্রিয়াজাত",
  pending: "মুলতুবি",
  member: "সদস্য",
  amount: "পরিমাণ",
  bank_acc_no: "ব্যাংক অ্যাকাউন্ট নং",
  deposit_date: "ডিপোজিটের তারিখ",
  deposit_method: "ডিপোজিট পদ্ধতি",
  approve: "অনুমোদন",
  reject: "প্রত্যাখ্যান",
  remark: "মন্তব্য",
  ticket_detail: "টিকিটের বিস্তারিত",
  promo: "প্রোমো",
  package: "প্যাকেজ",
  created_date: "তারিখ তৈরি করা হয়েছে",
  currency: "মুদ্রা",
  bank_acc_holder: "ব্যাংক এসিসি হোল্ডার",
  ref_no: "রেফারেন্স নং",
  vip: "ভিআইপি",
  modified_date: "সংশোধিত তারিখ",
  modified_by: "সংশোধিত দ্বারা",
  bank_member: "ব্যাংক সদস্য",
  bank_operator: "ব্যাংক অপারেটর",
  bank_name: "ব্যাংকের নাম",
  bank_acc_type: "ব্যাংক এসিসি টাইপ",
  account_balance: "দুদক বিএএল",
  threshold: "থ্রেশহোল্ড",
  incoming: "আসছে",
  outgoing: "বহির্মুখী",
  frequency: "ফ্রিকোয়েন্সি",
  reset_threshold: "রিসেট থ্রেশহোল্ড",
  adjust_balance: "অ্যাডজাস্ট ব্যালেন্স",
  bank_from: "ব্যাংক থেকে",
  bank_to: "ব্যাংক টু",
  attachment: "সংযুক্তি",
  sender_bank: "এস.ব্যাংক",
  sender_bank_acc_no: "এস.ব্যাংক অ্যাকাউন্ট নং",
  sender_bank_acc_holder: "এস.ব্যাঙ্ক অ্যাকাউন্ট হোল্ডার",
  audit: "অডিট",
  action_status: "অ্যাকশন স্ট্যাটাস",
  action_date: "অ্যাকশন ডেট",
  promotion: "প্রচার",
  promo_id: "প্রোমো আইডি",
  promo_name: "প্রোমো নাম",
  package_id: "প্যাকেজ আইডি",
  claim_type: "সি.টাইপ",
  bonus_rate: "বি.রেট",
  max_bonus: "এম.বোনাস",
  rollover: "রোলওভার",
  start_date: "শুরুর তারিখ",
  end_date: "সমাপ্তির তারিখ",
  adj_amount: "অ্যাডজাস্ট অ্যামাউন্ট",
  promotion_member: "পদোন্নতি সদস্য",
  on_going: "চলছে",
  knock_off: "নক অফ",
  all_ongoing: "সব চলছে",
  deposit_amount: "ডেপ অ্যামট",
  base_amount: "বেস অ্যামট",
  bonus_amount: "বোনাস অ্যামট",
  target_amount: "Trgt Amt",
  claim_date: "দাবির তারিখ",
  accumulate_win: "জয় সঞ্চয় করুন",
  accumulate_turnover: "টার্নওভার জমা করুন",
  bonus: "বোনাস",
  bonus_log: "বোনাস লগ",
  member_id: "সদস্য আইডি",
  before_balance: "ভারসাম্যের আগে",
  transfer_amount: "স্থানান্তরের পরিমাণ",
  after_balance: "ভারসাম্যের পরে",
  created_by: "নির্মিত",
  bonus_name: "বোনাস নাম",
  bonus_desc: "বোনাস বর্ণনা",
  bonus_type: "বোনাস টাইপ",
  add_promo: "প্রচার যোগ করুন",
  bonus_value: "বোনাস মান",
  attach_promo: "প্রচার সংযুক্ত করুন",
  daily_statement: "দৈনিক বিবৃতি",
  working_date: "ওয়ার্কিং ডিটি",
  opening_balance: "ওপেনিং ব্যালেন্স",
  turnover: "টার্নওভার",
  valid_turnover: "ভি.টার্নওভার",
  winlose: "উইনলস",
  withdrawal_amount: "ডাব্লুডিডাব্লু অ্যামট",
  closing_balance: "ক্লোজিং ব্যালেন্স",
  sub_total: "সাব টোটাল",
  grand_total: "গ্র্যান্ড টোটাল",
  daily_winlose: "ডেইলি উইনলোজ",
  game_result_slots: "গেম রেজাল্ট (স্লট)",
  game_result_livecasino: "গেম রেজাল্ট (লাইভক্যাসিনো)",
  game_result_rebate: "গেম রেজাল্ট (রিবেট)",
  game_result_sportsbook: "গেম রেজাল্ট (স্পোর্টসবুক)",
  game_result_cockfight: "গেম রেজাল্ট (মোরগের লড়াই)",
  game_result_rescue: "গেম রেজাল্ট (রেসকিউ)",
  game_result_others: "গেম রেজাল্ট (অন্যান্য)",
  bet_count: "বাজি গণনা",
  result_id: "রেজাল্ট আইডি",
  bet_time: "বাজি সময়",
  result_time: "রেজাল্ট সময়",
  payout: "পেআউট",
  game_type: "গেমের ধরন",
  game_name: "গেমের নাম",
  game_provider: "গেম প্রোভাইডার",
  reset: "রিসেট",
  mode: "মোড",
  balance: "ভারসাম্য",
  min_bal_knock_off_promo: "মিন বাল। (প্রচার অটো নক অফ করতে)",
  social_account: "সোশ্যাল অ্যাকাউন্ট",
  wechat: "উইচ্যাট",
  telegram: "টেলিগ্রাম",
  whatsapp: "হোয়াটসঅ্যাপ",
  facebook: "ফেসবুক",
  instagram: "ইনস্টাগ্রাম",
  login_log: "লগইন লগ",
  platform: "প্ল্যাটফর্ম",
  bank_statement: "ব্যাংক স্টেটমেন্ট",
  transfer_date: "স্থানান্তরের তারিখ",
  detail: "বিস্তারিত",
  date: "তারিখ",
  transfer_list: "স্থানান্তর তালিকা",
  credit: "ক্রেডিট",
  badge: "ব্যাজ",
  debit: "ডেবিট",
  month: "মাস",
  unblock: "অবরোধ মুক্ত করুন",
  unblock_member: "সদস্যকে অবরোধ মুক্ত করুন",
  unblock_operator: "অপারেটর আনব্লক করুন",
  referrer_id: "রেফারার আইডি",
  referrer_code: "রেফারার কোড",
  referral_code: "রেফারেল কোড",
  bonus_and_adjustment: "বোনাস এবং অ্যাডজাস্টমেন্ট",
  adjustment: "সমন্বয়",
  incoming_amount_threshold: "ইনকামিং অ্যামাউন্ট থ্রেশহোল্ড",
  outgoing_amount_threshold: "আউটগোয়িং অ্যামাউন্ট থ্রেশহোল্ড",
  knock_off_by: "নক অফ বাই",
  knock_off_date: "নক অফ ডেট",
  total_turnover: "মোট টার্নওভার",
  total_winlose: "টোটাল উইনলোজ",
  total_deposit: "মোট আমানত",
  total_member: "মোট সদস্য",
  active_player: "অ্যাক্টিভ প্লেয়ার",
  top_winner: "শীর্ষ বিজয়ী",
  top_loser: "টপ লুজার",
  winner: "বিজয়ী",
  loser: "লুজার",
  deposit_count: "ডেপ সিএনটি",
  withdrawal_count: "ডাব্লুডিডাব্লু সিএনটি",
  alert: "সতর্কতা",
  incoming_threshold: "ইন থ্রেস",
  incoming_frequency: "ফ্রিকোয়েন্সে",
  outgoing_threshold: "আউট থ্রেস",
  outgoing_frequency: "আউট ফ্রিকিউ",
  reset_password: "পাসওয়ার্ড রিসেট করুন",
  transfer: "স্থানান্তর",
  company_bank: "কোম্পানি ব্যাংক",
  company_bank_acc_no: "কোম্পানি ব্যাংক অ্যাকাউন্ট নং",
  company_bank_acc_holder: "কোম্পানি ব্যাংক অ্যাকাউন্ট হোল্ডার",
  registered_member: "নিবন্ধিত সদস্য",
  promotion_report: "প্রচার প্রতিবেদন",
  deposited_member: "ডিপোজিটেড মেম্বার",
  referred_member: "রেফার করা সদস্য",
  validated_on: "বৈধ হয়েছে",
  first_deposit: "ফার্স্ট ডিপোজিট",
  reward: "পুরষ্কার",
  inbox: "ইনবক্স",
  manual_bonus: "ম্যানুয়াল বোনাস",
  review: "রিভিউ",
  reviews: "পর্যালোচনা",
  review_list: "পর্যালোচনা তালিকা",
  review_detail: "পর্যালোচনা বিশদ",
  reply_review: "রিপ্লাই রিভিউ",
  comment: "মন্তব্য",
  reply: "উত্তর দিন",
  recipient_no: "প্রাপক নং",
  question : "প্রশ্ন",
  rating: "রেটিং",
  content: "বিষয়বস্তু",
  image: "চিত্র",
  monthly_rating: "মাসিক রেটিং",
  affiliate: "এজেন্ট",
  affiliate_list: "এজেন্ট তালিকা",
  affiliate_code: "এজেন্ট কোড",
  approved_by: "অনুমোদিত",
  approved_date: "অনুমোদিত তারিখ",
  bank_affiliate : "ব্যাংক এজেন্ট",
  bank_id: "ব্যাংক আইডি",
  ticket_detail_affiliate : "টিকিট ডিটেইল এজেন্ট",
  pending_application: "মুলতুবি আবেদন",
  pending_review_withdrawal: "বকেয়া এবং পর্যালোচনা প্রত্যাহার",
  unblock_affiliate : "আনব্লক এজেন্ট",
  wallet_adjust: "ওয়ালেট অ্যাডজাস্ট",
  comm_package: "যোগাযোগ প্যাকেজ",
  affiliate_id: "এজেন্ট আইডি",
  sub_account_detail: "সাব অ্যাকাউন্টের বিশদ",
  daily_winlose_affiliate : "ডেইলি উইনলোজ (এজেন্ট)",
  daily_deposit_affiliate : "ডেইলি ডিপোজিট (এজেন্ট)",
  export_excel: "এক্সেল রফতানি করুন",
  get_tac: "ওটিপি পান",
  tac_code: "ওটিপি কোড",
  expiry_date: "মেয়াদ শেষ হওয়ার তারিখ",
  inactive: "নিষ্ক্রিয়",
  last_deposit_date: "শেষ ডিপোজিটের তারিখ",
  coupon: "কুপন",
  allocated: "বরাদ্দকৃত",
  claimed: "দাবি করা হয়েছে",
  approved: "অনুমোদিত",
  coupon_code: "কুপন কোড",
  coupon_quota: "কুপন কোটা",
  current_allocated: "বর্তমান বরাদ্দকৃত",
  new_allocated: "নতুন বরাদ্দকৃত",
  update : "আপডেট",
  copy: "কপি",
  bonus_rate_percent : "বোনাস রেট (%)",
  coupon_desc: "কুপন বর্ণনা",
  both: "উভয়ই",
  issue_free_spin: "ফ্রি স্পিন ইস্যু করুন",
  game: "খেলা",
  max_win_amount: "ম্যাক্স উইন অ্যামাউন্ট",
  utm_list: "ইউটিএম তালিকা",
  search_by_member: "সদস্য দ্বারা অনুসন্ধান করুন",
  campaign: "ক্যাম্পেইন",
  deposited: "ডিপোজিটেড",
  search_by_id: "আইডি দ্বারা অনুসন্ধান করুন",
  get_bank_tac: "ব্যাংক ওটিপি পান",
  bank_statement_daily: "ব্যাংক স্টেটমেন্ট (দৈনিক)",
  transfer_type: "স্থানান্তরের ধরণ",
  audit_freebies_list: "অডিট ফ্রিবিজ তালিকা",
  acknowledge: "স্বীকার করুন",
  submit_acknowledgement: "স্বীকৃতি জমা দিন",
  is_ack: "ইজ অ্যাক",
  yes: "হ্যাঁ",
  no: "না",
  audit_rescue_fund_list: "অডিট রেসকিউ ফান্ড তালিকা",
  global_setting: "গ্লোবাল সেটিং",
  signup_ip: "সাইন আপ আইপি",
  last_login_ip: "শেষ লগইন আইপি",
  last_login_time: "শেষ লগইন সময়",
  link: "লিঙ্ক",
  is_default: "ডিফল্ট",
  is_public: "সর্বজনীন",
  bank_group: "ব্যাংক গ্রুপ",
  set_default: "ডিফল্ট সেট করুন",
  group_id: "গ্রুপ আইডি",
  group_name: "গ্রুপের নাম",
  provider_maintenance: "সরবরাহকারী রক্ষণাবেক্ষণ",
  provider_code: "সরবরাহকারী কোড",
  provider_name: "সরবরাহকারীর নাম",
  withdrawal_limit: "প্রত্যাহারের সীমা",
  limit_id: "লিমিট আইডি",
  limit_name: "সীমার নাম",
  daily_amount: "দৈনিক পরিমাণ",
  daily_frequency: "দৈনিক ফ্রিকোয়েন্সি",
  promotion_id: "প্রচার আইডি",
  promotion_name: "প্রচারের নাম",
  withhold_bonus: "বোনাস আটকে রাখুন",
  withhold_amount: "পরিমাণ আটকে রাখুন",
  withhold_amt: "উইথহোল্ড অ্যামট",
  max_withdraw_amt: "ম্যাক্স উইথ অ্যামট",
  max_withdraw_amount: "সর্বাধিক উত্তোলনের পরিমাণ",
  monday: "সোম",
  tuesday: "মঙ্গলবার",
  wednesday: "ওয়েড",
  thursday: "থু",
  friday: "ফ্রাই",
  saturday: "স্যাট",
  sunday: "সূর্য",
  start_time: "এস.টাইম",
  end_time: "ই.টাইম",
  day: "দিবস | দিনগুলি",
  coupon_status: "কুপন স্ট্যাটাস",
  campaign_id: "ক্যাম্পেইন আইডি",
  campaign_name: "প্রচারাভিযানের নাম",
  promotion_group: "প্রচার গ্রুপ",
  referee_list: "রেফারির তালিকা",
  account_verified: "অ্যাকাউন্ট যাচাই করা হয়েছে",
  verified_date: "যাচাইকৃত তারিখ",
  ticket_list: "টিকিট তালিকা",
  vip_id: "ভিআইপি আইডি",
  vip_name: "ভিআইপি নাম",
  self_rebate_rate: "স্ব-ছাড়ের হার(%)",
  downline_rebate_rate: "ডাউনলাইন রিবেট রেট (%)",
  provider: "সরবরাহকারী",
  match_id: "ম্যাচ আইডি",
  home_team: "হোম টিম",
  away_team: "অ্যাওয়ে টিম",
  home_team_new: "হোম টিম নিউ",
  away_team_new: "অ্যাওয়ে টিম নিউ",
  updated_by: "আপডেট করেছেন",
  updated_on: "আপডেট করা হয়েছে",
  home_score: "হোম স্কোর",
  away_score: "অ্যাওয়ে স্কোর",
  home_score_new: "হোম স্কোর নতুন",
  away_score_new: "অ্যাওয়ে স্কোর নতুন",
  team: "টিম",
  match_time: "ম্যাচের সময়",
  match_round: "ম্যাচ রাউন্ড",
  home_group: "হোম গ্রুপ",
  away_group: "অ্যাওয়ে গ্রুপ",
  match: "ম্যাচ",
  match_status: "ম্যাচ স্ট্যাটাস",
  insert: "সন্নিবেশ করুন",
  pin: "পিন",
  bet_list: "বাজি তালিকা",
  result_list: "ফলাফল তালিকা",
  bet_id: "বেট আইডি",
  bet_home: "বেট হোম",
  bet_away: "বাজি ধরুন",
  bet_on: "বাজি ধরুন",
  min_deposit: "সর্বনিম্ন আমানত",
  min_withdrawal: "ন্যূনতম প্রত্যাহার",
  raise_deposit_ticket: "ডিপোজিট টিকিট বাড়ান",
  method: "পদ্ধতি",
  one_time_depositor: "ওয়ান টাইম ডিপোজিটর",
  current_month_non_depositor: "বর্তমান মাসের অ-আমানতকারী",
  current_month_no_login: "বর্তমান মাস কোনও লগইন নেই",
  ticket_date: "টিকিটের তারিখ",
  ftd_amount: "এফটিডি অ্যামট",
  bonus_issue: "বোনাস ইস্যু",
  promotion_summary: "পদোন্নতির সারাংশ",
  promotion_summary_detail: "প্রচারের সারাংশ (বিস্তারিত)",
  claim_frequency: "ক্লেইম ফ্রিকোয়েন্সি",
  provider_list: "সরবরাহকারীর তালিকা",
  platform_winlose: "প্ল্যাটফর্ম উইনলোজ",
  adjustment_amount: "অ্যাডজ অ্যামট",
  referee_count: "রেফারি সিএনটি",
  category: "ক্যাটাগরি",
  update_vip: "ভিআইপি আপডেট করুন",
  promotion_signup: "প্রচার সাইনআপ",
  provider_bet_limit: "সরবরাহকারীর বাজি সীমা",
  update_member_bet_limit: "সদস্য বাজি সীমা আপডেট করুন",
  bet_limit: "বাজি সীমা",
  sports_game: "খেলাধুলা/খেলা",
  league_name: "লীগের নাম",
  home_team_name: "হোম টিমের নাম",
  away_team_name: "অ্যাওয়ে টিমের নাম",
  wl_status: "উইনলোজ স্ট্যাটাস",
  available_bank_account: "উপলভ্য ব্যাংক অ্যাকাউন্ট",
  group_bank_account: "গ্রুপ ব্যাংক অ্যাকাউন্ট",
  edit_bank_group: "ব্যাংক গ্রুপ সম্পাদনা করুন",
  edit_bank_account_group: "ব্যাংক অ্যাকাউন্ট গ্রুপ সম্পাদনা করুন",
  redeposit: "রিডিপোজিট",
  upline: "আপলাইন",
  downline: "ডাউনলাইন",
  available_promotion: "উপলব্ধ প্রচার",
  group_promotion: "গ্রুপ প্রমোশন",
  edit_promotion_group: "প্রচার গ্রুপ সম্পাদনা করুন",
  edit_promotion_group_norm: "গ্রুপে প্রচার পরিচালনা করুন",
  balance_before: "ব্যালেন্স বিফোর",
  balance_after: "পরে ভারসাম্য",
  signup_count: "সাইনআপ সিএনটি",
  verified_count: "ভিআরএফ গণনা",
  active_member: "অ্যাক্টিভ এমবিএম",
  ftd_count: "এফটিডি সিএনটি",
  daily_summary_company: "দৈনিক সারসংক্ষেপ (কোম্পানি)",
  daily_summary_operator: "দৈনিক সারসংক্ষেপ (অপারেটর)",
  daily_summary_member: "দৈনিক সারসংক্ষেপ (সদস্য)",
  daily_ledger_operator: "ডেইলি লেজার (অপারেটর)",
  bonus_list: "বোনাস তালিকা",
  ltd_date: "লিমিটেড তারিখ",
  adjustment_log: "অ্যাডজাস্টমেন্ট লগ",
  get_inbox: "ইনবক্স পান",
  is_claimed: "দাবি করা হয়েছে",
  mix_parlay: "মিক্স পার্লে",
  event: "ইভেন্ট",
  result_changes_log: "ফলাফল লগ পরিবর্তন করে",
  view_detail: "বিস্তারিত দেখুন",
  total_referee: "টোটাল রেফারি",
  verified_signup: "যাচাইকৃত / সাইনআপ",
  ftd: "এফটিডি | ফার্স্ট টাইম ডিপোজিট",
  raw_msg: "কাঁচা বার্তা",
  unselect_all: "সমস্ত আনসিলেক্ট করুন",
  select_all: "সমস্ত নির্বাচন করুন",
  edit_bet_limit: "বাজি সীমা সম্পাদনা করুন",
  provider_game_off: "সরবরাহকারী গেম বন্ধ",
  provider_hot_game: "সরবরাহকারী হট গেম",
  game_id : "গেম আইডি",
  game_list: "গেম লিস্ট",
  off_list: "অফ লিস্ট",
  provider_rtp: "সরবরাহকারী আরটিপি",
  rtp: "আরটিপি",
  signup_date: "সাইন আপের তারিখ",
  free_credit: "ফ্রি ক্রেডিট",
  downline_rebate: "ডাউনলাইন রিবেট",
  game_rebate: "গেম রিবেট",
  rebate: "ছাড়",
  ftd_date: "এফটিডি তারিখ",
  provider_winlose_company: "সরবরাহকারী উইনলোজ (সংস্থা)",
  provider_winlose_operator: "সরবরাহকারী উইনলোজ (অপারেটর)",
  already_hit: "ইতিমধ্যে আঘাত করা হয়েছে",
  ongoing: "চলছে",
  members_export: "সদস্য (রফতানি)",
  get_recent_deposit: "সাম্প্রতিক আমানত পান",
  recent_deposit: "সাম্প্রতিক আমানত",
  survey_list: "জরিপ তালিকা",
  modified_on: "সংশোধিত চালু",
  cms: "সিএমএস",
  announcement_banner: "ঘোষণা ব্যানার",
  promotion_banner: "প্রচার ব্যানার",
  slide_banner: "স্লাইড ব্যানার",
  seo_page: "এসইও পৃষ্ঠা",
  en_title: "শিরোনাম (EN)",
  cn_title: "শিরোনাম (সিএন)",
  local_title: "শিরোনাম (স্থানীয়)",
  en_img: "চিত্র (EN)",
  cn_img: "চিত্র (সিএন)",
  local_img: "চিত্র (স্থানীয়)",
  before_login: "লগইন করার আগে",
  after_login: "লগইন করার পরে",
  en: "ইএন",
  move_up: "সরে যাও",
  move_down: "সরে যাও",
  banner_type: "ব্যানার টাইপ",
  default_order: "ডিফল্ট অর্ডার",
  item_order: "আইটেম অর্ডার",
  title: "শিরোনাম",
  banner_id: "ব্যানার আইডি",
  order: "অর্ডার",
  body: "শরীর",
  en_image: "চিত্র (EN)",
  local_image: "চিত্র (স্থানীয়)",
  move: "সরান",
  en_img_desktop: "ইমেজ ডেস্কটপ (ইএন)",
  cn_img_desktop: "ইমেজ ডেস্কটপ (সিএন)",
  local_img_desktop: "ইমেজ ডেস্কটপ (স্থানীয়)",
  en_img_mobile: "ইমেজ মোবাইল (ইএন)",
  cn_img_mobile: "ইমেজ মোবাইল (সিএন)",
  local_img_mobile: "ইমেজ মোবাইল (স্থানীয়)",
  login_required: "লগইন প্রয়োজন",
  new_window_tab: "নতুন উইন্ডো / ট্যাব",
  current_page: "বর্তমান পৃষ্ঠা",
  target: "টার্গেট",
  event_filter: "ইভেন্ট ফিল্টার",
  alt: "অল্ট",
  href: "হ্রেফ",
  image_desktop: "ডেস্কটপ ইমেজ",
  image_mobile: "মোবাইল ইমেজ",
  en_alt: "Alt (EN)",
  local_alt: "অল্ট (স্থানীয়)",
  en_href: "Href (EN)",
  local_href: "Href (স্থানীয়)",
  en_image_desktop: "ডেস্কটপ ইমেজ (ইএন)",
  active_period: "সক্রিয় সময়কাল",
  en_item: "আইটেম (EN)",
  local_item: "আইটেম (স্থানীয়)",
  meta_title: "মেটা শিরোনাম",
  meta_keywords: "মেটা কীওয়ার্ডস",
  meta_url: "মেটা ইউআরএল",
  meta_canonical: "মেটা ক্যানোনিক্যাল",
  meta_author: "মেটা লেখক",
  meta_publisher: "মেটা পাবলিশার",
  meta_lang: "মেটা ল্যাং",
  meta_desc: "মেটা ডেস্ক",
  meta_image: "মেটা ইমেজ",
  page: "পৃষ্ঠা",
  item: "আইটেম",
  remove_desktop_image: "ডেস্কটপ চিত্র সরান",
  remove_mobile_image: "মোবাইল চিত্র সরান",
  page_name: "পৃষ্ঠার নাম",
  login_date: "লগইন তারিখ",
  ftd_amount_min: "সর্বনিম্ন এফটিডি পরিমাণ",
  ftd_amount_max: "ম্যাক্স এফটিডি অ্যামাউন্ট",
  fl_provider_code: "প্রথম লঞ্চ সরবরাহকারী",
  fl_game_id: "প্রথম লঞ্চ গেম আইডি",
  fl_game_name: "প্রথম লঞ্চ গেমের নাম",
  top_deposit: "শীর্ষ আমানত",
  top_withdrawal: "শীর্ষ প্রত্যাহার",
  top_promotion: "শীর্ষ প্রচার",
  outstanding_balance: "আউটস্ট্যান্ডিং ব্যালেন্স",
  last_update_time: "শেষ আপডেটের সময়",
  trace: "ট্রেস",
  trace_outstanding: "ট্রেস আউটস্ট্যান্ডিং",
  outstanding: "অসাধারণ",
  clear_outstanding: "ক্লিয়ার আউটস্ট্যান্ডিং",
  meta_image_url: "মেটা ইমেজ ইউআরএল",
  member_bonus: "সদস্য বোনাস",
  crm_list: "সিআরএম তালিকা",
  advance_search: "অগ্রিম অনুসন্ধান",
  deposit_count_from: "থেকে ডিপোজিট কাউন্ট",
  deposit_count_to: "ডিপোজিট কাউন্ট টু",
  deposit_amount_from: "থেকে ডিপোজিটের পরিমাণ",
  deposit_amount_to: "ডিপোজিটের পরিমাণ",
  min_day_no_login: "সর্বনিম্ন দিন কোনও লগইন নেই",
  min_day_no_deposit: "সর্বনিম্ন দিন কোনও আমানত নেই",
  last_login: "শেষ লগইন",
  last_deposit: "শেষ আমানত",
  phone: "ফোন",
  email: "ইমেইল",
  ip_whitelist: "আইপি হোয়াইটলিস্ট",
  ip: "আইপি",
  payment_option: "পেমেন্ট অপশন",
  payment_mode: "পেমেন্ট মোড",
  payment_desc: "পেমেন্ট ডেস্ক",
  success: "সাফল্য",
  failed: "ব্যর্থ",
  bank_member_ewallet: "ব্যাংক সদস্য (ই-ওয়ালেট)",
  processing: "প্রক্রিয়াকরণ",
  recipient_bank_id: "আর.ব্যাংক আইডি",
  recipient_bank_acc_no: "আর.ব্যাংক এসিসি নং",
  ticket_auto_withdrawal_log: "টিকিট লগ (স্বয়ংক্রিয় প্রত্যাহার)",
  resubmit_ticket: "টিকিট পুনরায় জমা দিন",
  ticket_export: "টিকিট (রফতানি)",
  export_deposit: "রফতানি (আমানত)",
  export_deposit_all: "সমস্ত (আমানত) রফতানি করুন",
  export_withdrawal: "রফতানি (প্রত্যাহার)",
  export_withdrawal_all: "সমস্ত রপ্তানি করুন (প্রত্যাহার)",
  export_member_all: "সমস্ত (সদস্য) রফতানি করুন",
  processed_rejected: "প্রক্রিয়াজাত (প্রত্যাখ্যান)",
  channel: "চ্যানেল",
  influencer: "প্রভাবশালী",
  ticket_id: "টিকিট আইডি",
  recommend: "সুপারিশ",
  sequence: "সিকোয়েন্স",
  statement_info: "বিবৃতি তথ্য",
  slots: "স্লট",
  livecasino: "লাইভক্যাসিনো",
  sportsbook: "খেলাধুলা",
  cockfight: "মোরগের লড়াই",
  member_list: "সদস্য তালিকা",
  operator: "অপারেটর",
  game_balance: "গেম ব্যালেন্স",
  claim_limit: "দাবির সীমা",
  max_withdraw_multiple: "ম্যাক্স উইথড্র মাল্টিপল",
  payment_gateway: "পেমেন্ট গেটওয়ে",
  min_limit: "সর্বনিম্ন সীমা",
  max_limit: "সর্বোচ্চ সীমা",
  total: "মোট",
  rebate_summary: "ছাড়ের সারাংশ",
  rebate_summary_daily: "রিবেট সারাংশ ডেইলি",
  rebate_member: "রিবেট মেম্বার",
  self: "স্ব",
  system_balance: "সিস্টেম ব্যালেন্স",
  rejected_onload: "প্রত্যাখ্যান করা হয়েছে (অনলোড)",
  no_bonus: "বোনাস নেই",
  audit_ticket: "অডিট টিকিট",
  review_ticket: "রিভিউ টিকিট",
  edit_promotion_group_norm_seq: "গ্রুপে প্রচার ক্রম পরিচালনা করুন",
  signup_bonus: "সাইনআপ বোনাস",
  settlement_type: "বন্দোবস্তের ধরণ",
  carry_over: "ক্যারি ওভার",
  comm_sports: "কমিশন (খেলাধুলা)",
  comm_slots: "কমিশন (স্লট)",
  comm_livecasino: "কমিশন (লাইভক্যাসিনো)",
  comm_cockfight: "কমিশন (মোরগের লড়াই)",
  comm_others: "কমিশন (অন্যান্য)",
  update_comm: "কমিশন আপডেট করুন",
  update_carry_over: "আপডেট ক্যারি ওভার",
  ewallet: "ই-ওয়ালেট",
  withdrawal_list: "প্রত্যাহারের তালিকা",
  audit_withdrawal: "অডিট প্রত্যাহার",
  daily_withdrawal: "দৈনিক প্রত্যাহার",
  adjustment_log_affiliate : "অ্যাডজাস্টমেন্ট লগ",
  daily_statement_affiliate : "দৈনিক বিবৃতি (এজেন্ট)",
  earning: "উপার্জন",
  pnl: "পি অ্যান্ড এল",
  review_affiliate_ticket: "রিভিউ এজেন্ট টিকিট",
  audit_affiliate_ticket: "অডিট এজেন্ট টিকিট",
  turnover_downline: "টার্নওভার (ডাউনলাইন)",
  valid_turnover_downline: "বৈধ টার্নওভার (ডাউনলাইন)",
  winlose_downline: "উইনলস (ডাউনলাইন)",
  bet_count_downline: "বাজি গণনা (ডাউনলাইন)",
  turnover_member: "টার্নওভার (সদস্য)",
  valid_turnover_member: "বৈধ টার্নওভার (সদস্য)",
  winlose_member: "উইনলস (সদস্য)",
  bet_count_member: "বাজি গণনা (সদস্য)",
  dashboard_affiliate : "ড্যাশবোর্ড (এজেন্ট)",
  total_agent: "টোটাল এজেন্ট",
  top_turnover: "শীর্ষ টার্নওভার",
  bonus_count: "বোনাস গণনা",
  deposit_amount_downline: "ডিপোজিট অ্যামাউন্ট (ডাউনলাইন)",
  deposit_count_downline: "ডিপোজিট কাউন্ট (ডাউনলাইন)",
  bonus_amount_downline: "বোনাস পরিমাণ (ডাউনলাইন)",
  bonus_count_downline: "বোনাস গণনা (ডাউনলাইন)",
  deposit_amount_member: "আমানতের পরিমাণ (সদস্য)",
  deposit_count_member: "ডিপোজিট কাউন্ট (মেম্বার)",
  bonus_amount_member: "বোনাস পরিমাণ (সদস্য)",
  bonus_count_member: "বোনাস গণনা (সদস্য)",
  verified: "যাচাই করা হয়েছে",
  round_id: "রাউন্ড আইডি",
  unfinish_round: "অসমাপ্ত রাউন্ড",
  smartico_bonus_report: "স্মার্টিকো বোনাস রিপোর্ট",
  unclaimed_amount: "দাবিহীন পরিমাণ",
  claimed_amount: "দাবি করা পরিমাণ",
  unclaimed_count: "দাবিহীন গণনা",
  claimed_count: "দাবি করা গণনা",
  submit_time: "তারিখ তৈরি করা হয়েছে",
  deposit_time: "সংশোধিত তারিখ",
  funds_list: "টিকিট তালিকা",
  fund_transfer_provider: "তহবিল স্থানান্তর সরবরাহকারী",
  daifu_list_auto_withdrawal: "টিকিট তালিকা (স্বয়ংক্রিয় প্রত্যাহার)",
  btn_href: "বোতাম হ্রেফ",
  btn_text: "বোতাম পাঠ্য",
  recent_inbox_claim: "সাম্প্রতিক ইনবক্স দাবি",
  raise_deposit_ticket_gateway: "রেইজ ডিপোজিট টিকিট (গেটওয়ে)",
  gateway_acc: "গেটওয়ে অ্যাকাউন্ট",
  provider_winlose_member: "সরবরাহকারী উইনলোজ (সদস্য)",
  review_by: "পর্যালোচনা দ্বারা",
  daifu_list_auto_withdrawal_export: "টিকিট রপ্তানি (স্বয়ংক্রিয় প্রত্যাহার)",
  retention: "রিটেনটন",
  current_month_active_user: "বর্তমান মাসের সক্রিয় ব্যবহারকারী",
  current_month_active: "বর্তমান মাস সক্রিয়",
  first_month: "প্রথম মাস",
  fmwinlose: "FMWinlose",
  fmdeposit_amount: "এফএমডিপোজিট পরিমাণ",
  cohort: "কোহর্ট",
  promotion_withdrawal_summary: "প্রচার প্রত্যাহারের সারাংশ",
  promotion_withdrawal_summary_detail: "প্রচার প্রত্যাহারের সারাংশ (বিস্তারিত)",
  unique_player: "অনন্য খেলোয়াড়",
  year: "বছর | বছর",
  audit_time_modified: "সংশোধিত তারিখ",
  audit_time_created: "তারিখ তৈরি করা হয়েছে",
  approve_time: "সংশোধিত তারিখ",
  unique_login_count: "ইউ.লগইন সিএনটি",
  unique_deposit_count: "ইউ.ডি.ই.পি. সি.এন.টি",
  unique_withdrawal_count: "ইউ.ডব্লিউ.ডি.ডাব্লু সি.এন.টি",
  second_deposit_count: "এস.ডি.ই.পি. সি.এন.টি",
  unique_login: "অনন্য লগইন",
  unique_withdrawal: "অনন্য প্রত্যাহার",
  second_deposit: "দ্বিতীয় আমানত",
  deposit_withdrawal_different: "ডেপ ডাব্লুডিডাব্লু ডিফ",
  ngr: "এনজিআর",
  audit_list: "অডিট তালিকা",
  rollback_count: "রোলব্যাক গণনা",
  rejected_ticket_id: "টিকিট আইডি প্রত্যাখ্যান করা হয়েছে",
  rollback: "রোলব্যাক",
  recipient_bank_acc_holder: "আর.ব্যাঙ্ক অ্যাকাউন্ট হোল্ডার",
  reject_date: "আর.ডেট",
  processing_date: "পি.ডেট",
  manual_approve: "অনুমোদন (ম্যানুয়াল)",
  pending_review_funds: "পেন্ডিং অ্যান্ড রিভিউ টিকিট",
  table_id: "টেবিল আইডি",
  member_label: "সদস্য লেবেল",
  label_name: "লেবেলের নাম",
  label: "লেবেল",
  available_label: "উপলভ্য লেবেল",
  iframe: "ইফ্রেম",
  iframe_url: "আইফ্রেম ইউআরএল",
  exchange_rate: "বিনিময় হার",
  rate: "রেট",
  rate_php: "রেট পিএইচপি",
  ticket_withdrawal_rollback: "টিকিট প্রত্যাহার রোলব্যাক",
  smartico_bonus_report_expired: "স্মার্টিকো বোনাস রিপোর্ট (মেয়াদোত্তীর্ণ)",
  reward_type: "পুরষ্কারের ধরণ",
  turnover_rebate: "টার্নওভার রিবেট",
  turnover_rebate_1: "ভিআইপি টিয়ার",
  turnover_rebate_2: "টার্নওভার টিয়ার",
  vip_cycle_day: "ভিআইপি সাইকেল দিবস",
  is_addon: "অ্যাডন",
  no_reward: "কোনও পুরষ্কার নেই",
  cash: "নগদ",
  cs: "গ্রাহক পরিষেবা",
  social_platform: "সোশ্যাল প্ল্যাটফর্ম",
  edit_vip: "ভিআইপি সম্পাদনা করুন",
  edit_vip_provider: "ভিআইপি সরবরাহকারী সম্পাদনা করুন",
  turnover_tier: "টার্নওভার টিয়ার",
  rebate_rate: "রিবেট রেট",
  edit_turnover_tier: "টার্নওভার স্তর সম্পাদনা করুন",
  delete_turnover_tier: "টার্নওভার স্তর মুছুন",
  vip_log: "ভিআইপি লগ",
  member_full_record: "সদস্যের সম্পূর্ণ রেকর্ড",
  before: "আগে",
  after: "পরে",
  maintain: "রক্ষণাবেক্ষণ",
  actual_rebate: "প্রকৃত ছাড়",
  rounded_rebate: "বৃত্তাকার ছাড়",
  rebate_mode: "রিবেট মোড",
  inbox_id: "ইনবক্স আইডি",
  rebate_type: "রিবেট টাইপ",
  promotion_type: "প্রচারের ধরণ",
  bonus_rate_1: "রেট 1 (%)",
  bonus_rate_2: "রেট 2 (%)",
  bonus_rate_3: "রেট 3 (%)",
  bonus_rate_4: "রেট 4 (%)",
  bonus_rate_5: "রেট 5 (%)",
  bonus_rate_6: "রেট 6 (%)",
  bonus_rate_7: "রেট 7 (%)",
  bonus_rate_8: "রেট 8 (%)",
  bonus_rate_9: "রেট 9 (%)",
  bonus_rate_10: "রেট 10 (%)",
  delete_all: "সব মুছে ফেলুন",
  rescue_fund: "রেসকিউ ফান্ড",
  up: "আপ",
  down: "ডাউন",
  rate_percent: "রেট %",
  cycle: "সাইকেল",
  actual_amount: "প্রকৃত পরিমাণ",
  rounded_amount: "বৃত্তাকার পরিমাণ",
  rescue_id: "রেসকিউ আইডি",
  rescue_name: "রেসকিউ নাম",
  min_lose: "মিন লস",
  max_payout: "সর্বোচ্চ পেআউট",
  payout_method: "পেআউট পদ্ধতি",
  target_group: "টার্গেট গ্রুপ",
  member_vip_id: "সদস্য ভিআইপি আইডি",
  daily: "দৈনিক",
  weekly: "সাপ্তাহিক",
  monthly: "মাসিক",
  edit_batch: "ব্যাচ সম্পাদনা করুন",
  current_level: "বর্তমান স্তর",
  next_level: "পরবর্তী স্তর",
  bet_value: "বাজি মান",
  line_bet: "লাইন বেট",
  total_round: "মোট রাউন্ড",
  audit_by: "অডিট দ্বারা",
  possible_next_level: "সম্ভাব্য পরবর্তী স্তর",
  maintain_deposit: "আমানত বজায় রাখুন",
  maintain_turnover: "টার্নওভার বজায় রাখুন",
  starting_deposit: "ডিপোজিট শুরু করা",
  starting_turnover: "টার্নওভার শুরু হচ্ছে",
  cycle_deposit: "সাইকেল ডিপোজিট",
  cycle_turnover: "সাইকেল টার্নওভার",
  vip_list: "ভিআইপি তালিকা",
  up_maintain: "আপ রক্ষণাবেক্ষণ",
  down_lowest: "ডাউন লোয়েস্ট",
  manual: "ম্যানুয়াল",
  daily_winlose_game: "ডেইলি উইনলোজ (গেম)",
  actionaff: "অ্যাকশন (এজেন্ট)",
  onload: "অনলোড",
  update_status: "স্ট্যাটাস আপডেট করুন",
  role_settings: "ভূমিকা সেটিংস",
  customer_services: "গ্রাহক পরিষেবা",
  marketing: "মার্কেটিং",
  finance: "অর্থ",
  payment: "পেমেন্ট",
  risk_management: "ঝুঁকি ব্যবস্থাপনা",
  pt: "পিটি",
  wallet_history: "ওয়ালেট ইতিহাস",
  ticket_amount: "টিকিটের পরিমাণ",
  ignore_risk: "ঝুঁকি উপেক্ষা করুন",
  permitted_amount: "অনুমোদিত পরিমাণ",
  all_pending_ticket: "সমস্ত মুলতুবি টিকিট",
  rescue_fund_summary: "রেসকিউ ফান্ডের সারাংশ",
  rescue_fund_summary_daily: "রেসকিউ ফান্ড সারাংশ ডেইলি",
  rescue_fund_member: "রেসকিউ ফান্ড মেম্বার",
  master: "মাস্টার",
  account_type: "অ্যাকাউন্টের ধরণ",
  freeze: "ফ্রিজ",
  domain_member_setup: "সদস্য সাইট ডোমেন সেটআপ",
  domain: "ডোমেইন",
  domain_list: "ডোমেন তালিকা",
  domain_application: "ডোমেন অ্যাপ্লিকেশন",
  domain_status: "ডোমেন স্ট্যাটাস",
  domain_group: "ডোমেইন গ্রুপ",
  operator_id: "অপারেটর আইডি",
  domain_type: "ডোমেন টাইপ",
  module: "মডিউল",
  template: "টেমপ্লেট",
  custom: "কাস্টম",
  default: "ডিফল্ট",
  payment_provider: "পেমেন্ট প্রোভাইডার",
  payment: "পেমেন্ট",
  deactivate: "নিষ্ক্রিয়",
  name_server: "নাম সার্ভার",
  server_account: "সার্ভার অ্যাকাউন্ট",
  service_provider: "পরিষেবা সরবরাহকারী",
  process: "প্রক্রিয়া",
  provider_operator: "সরবরাহকারী অপারেটর",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "গ্লোবাল সেটিংস",
  second_id: "দ্বিতীয় আইডি",
  unverified: "যাচাই করা হয়নি",
  pt_affiliate : "এজেন্ট প্ল্যাটফর্ম চার্জ (%)",
  recipient_bank: "প্রাপক ব্যাংক",
  deposit_type: "ডিপোজিট টাইপ",
  security_fund: "সিকিউরিটি ফান্ড",
  adjust_balance_op: "অপারেটর ওয়ালেট অ্যাডজাস্ট করুন",
  adjust_security_deposit_op: "অপারেটর সিকিউরিটি ফান্ড অ্যাডজাস্ট করুন",
  marquee: "মার্কি",
  marquee_content: "মার্কি সামগ্রী",
  edit_marquee: "মার্কি সম্পাদনা করুন",
  domain_available: "ডোমেন উপলব্ধ",
  daily_withdrawal_frequency: "দৈনিক প্রত্যাহারের ফ্রিকোয়েন্সি",
  maintenance: "রক্ষণাবেক্ষণ",
  max_withdrawal: "সর্বোচ্চ প্রত্যাহার",
  min_balance: "ন্যূনতম ব্যালেন্স",
  affiliate_report: "এজেন্ট রিপোর্টস",
  cash_balance: "ক্যাশ ব্যালেন্স",
  copy_success: "সফলভাবে অনুলিপি করুন!",
  copy_failed: "অনুলিপি ব্যর্থ হয়েছে!",
  your_website: "আপনার ওয়েবসাইট",
  correction_promo: "প্রচার যোগ করুন",
  others: "অন্যান্য",
  audit_log: "অডিট লগ",
  view: "ভিউ",
  price: "দাম",
  package_level: "প্যাকেজ লেভেল",
  bo_right: "বিও রাইট",
  english: "ইংরেজী",
  simplified_chinese: "চীনা (সিএন)",
  traditional_chinese: "চাইনিজ (TW)",
  philippine: "ফিলিপাইন",
  thai: "থাই",
  vietnamese: "ভিয়েতনামী",
  indonesian: "ইন্দোনেশিয়ান",
  myanmar: "মায়ানমার",
  japanese: "জাপানি",
  korean: "কোরিয়ান",
  package_type: "প্যাকেজ টাইপ",
  full_back_office_access_right: "সম্পূর্ণ ব্যাক অফিস অ্যাক্সেস রাইট",
  read_only_back_office: "রিডঅনলি ব্যাক অফিস",
  language: "ভাষা",
  lang_code: "ভাষা কোড",
  description: "বর্ণনা",
  provider_type: "সরবরাহকারীর ধরণ",
  logo: "লোগো",
  theme_provider: "থিম সরবরাহকারী",
  theme_content: "থিম কনটেন্ট",
  content_id: "কনটেন্ট আইডি",
  content_desc: "কন্টেন্ট ডেস্ক",
  theme_content_position: "থিম কন্টেন্ট পজিশন",
  theme: "থিম",
  theme_code: "থিম কোড",
  theme_name: "থিমের নাম",
  color: "রঙ",
  position: "অবস্থান",
  site_name: "সাইটের নাম",
  theme_color: "থিমের রঙ",
  theme_purchased: "থিম কেনা হয়েছে",
  total_purchased: "মোট কেনা",
  purchased_date: "পি. তারিখ",
  purchase: "ক্রয়",
  total_site: "মোট সাইট",
  content_setup: "কন্টেন্ট সেটআপ",
  site_list: "সাইট তালিকা",
  site_id: "সাইট আইডি",
  draft_version: "খসড়া। Ver.",
  prod_version: "প্রোড. ভার্.",
  production_version: "প্রোডাকশন ভার্সন",
  info: "তথ্য",
  setting: "সেটিং",
  site_info: "সাইটের তথ্য",
  menu: "মেনু",
  game_menu: "গেম মেনু",
  special_menu: "বিশেষ মেনু",
  setting_menu: "সেটিং মেনু",
  error: "ত্রুটি",
  sync_all: "সমস্ত সিঙ্ক করুন",
  theme_content_group: "থিম কন্টেন্ট গ্রুপ",
  content_group: "কন্টেন্ট গ্রুপ",
  content_group_desc: "কন্টেন্ট গ্রুপ ডেস্ক",
  parent_content_id: "প্যারেন্ট কন্টেন্ট আইডি",
  bo_default_domain: "বিও ডিফল্ট ডোমেন",
  domain_id: "ডোমেন আইডি",
  deactive: "নিষ্ক্রিয়",
  site_sync: "সাইট সিঙ্ক",
  upload: "আপলোড",
  comingSoon: "শীঘ্রই আসছে",
  profile_setting: "প্রোফাইল সেটিং",
  bank: "ব্যাংক",
  company: "কোম্পানি",
  own: "নিজস্ব",
  operator_setting: "অপারেটর সেটিং",
  external_id: "প্রাক্তন আইডি",
  ticket: "টিকিট",
  bank_owner: "ব্যাংক মালিক",
  exchanged_currency: "বিনিময় মুদ্রা",
  company_bank_owner: "কোম্পানি ব্যাংক মালিক",
  ticket_list_member: "টিকিট তালিকা (সদস্য)",
  game_name_exclude: "গেমের নাম বাদ দিন",
  tab: "ট্যাব",
  about_us: "আমাদের সম্পর্কে",
  privacy_policy: "গোপনীয়তা নীতি",
  responsible_gaming: "দায়িত্বশীল গেমিং",
  banking: "ব্যাংকিং",
  faqs: "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী",
  advertisement: "বিজ্ঞাপন",
  px_pixel_id: "পিএক্স পিক্সেল আইডি",
  px_token: "পিএক্স টোকেন",
  af_dev_key: "আফ দেব কী",
  af_apps_id: "এএফ অ্যাপস আইডি",
  pp_tid: "পিপি টিআইডি",
  pp_pid: "পিপি পিআইডি",
  pp_aid: "পিপি এইড",
  gtm_id: "জিটিএম আইডি",
  service_provider_url: "পরিষেবা সরবরাহকারী ইউআরএল",
  script_inject: "স্ক্রিপ্ট ইনজেকশন",
  head_script: "হেড স্ক্রিপ্ট",
  body_script: "বডি স্ক্রিপ্ট",
  ads_id: "বিজ্ঞাপন আইডি",
  member_detail: "সদস্যের বিস্তারিত",
  memberreport: "সদস্য প্রতিবেদন",
  member_log: "সদস্য লগ",
  general: "জেনারেল",
  top_theme: "শীর্ষ থিম",
  hot_game: "হট গেম",
  hot_list: "হট লিস্ট",
  new_game: "নতুন খেলা",
  popular_game: "জনপ্রিয় খেলা",
  featured_game: "বৈশিষ্ট্যযুক্ত খেলা",
  new_list: "নতুন তালিকা",
  popular_list: "জনপ্রিয় তালিকা",
  featured_list: "বৈশিষ্ট্যযুক্ত তালিকা",
  provider_new_game: "সরবরাহকারী নতুন গেম",
  provider_popular_game: "সরবরাহকারী জনপ্রিয় গেম",
  provider_featured_game: "সরবরাহকারী বৈশিষ্ট্যযুক্ত গেম",
  website: "ওয়েবসাইট",
  site_customization: "সাইট কাস্টমাইজেশন",
  export_all: "সব রপ্তানি করুন",
  export_one: "রফতানি (বর্তমান পৃষ্ঠা)",
  daily_ledger: "ডেইলি লেজার",
  daily_ledger_member: "ডেইলি লেজার (সদস্য)",
  promotion_signup_unused: "অব্যবহৃত সাইনআপ প্রচার",
  promotion_signup_ongoing: "চলমান সাইনআপ প্রচার",
  promotion_signup_winlose: "সাইনআপ প্রচার উইনলোজ",
  promotion_signup_winlose_operator: "সাইনআপ প্রচার উইনলোজ (অপারেটর)",
  promotion_signup_winlose_member: "সাইনআপ প্রচার উইনলোজ (সদস্য)",
  total_player_balance: "মোট প্লেয়ার ব্যালেন্স",
  search_all: "সার্চ অল",
  mbsetting: "সেটিংস",
  todays_highlights: "আজকের হাইলাইটস",
  deposit_player: "ডিপোজিট প্লেয়ার",
  withdrawal_player: "উইথড্রয়াল প্লেয়ার",
  kill_rate: "কিল রেট",
  login_player: "লগইন প্লেয়ার",
  operation_management: "অপারেশন",
  game_management: "খেলা",
  member_management: "সদস্য",
  affiliate_management: "এজেন্ট",
  promotion_management: "প্রচার",
  mbcampaign: "ক্যাম্পেইন",
  promo_allday: "সারাদিন",
  promo_daily: "দৈনিক",
  promo_daily_first_deposit: "দৈনিক ফার্স্ট ডিপোজিট",
  promo_deposit_monthly: "মাসিক আমানত গণনা",
  promo_deposit_signup: "ডিপোজিট কাউন্ট সাইনআপ",
  promo_deposit_weekly: "সাপ্তাহিক আমানত গণনা",
  promo_newbie: "নবাগত",
  promo_once: "একবার",
  dd_review: "রিভিউ",
  game_provider_management: "সরবরাহকারী",
  exchanged_amount: "বিনিময় পরিমাণ",
  operator_summary: "অপারেটর সারাংশ",
  business_id: "বিজনেস আইডি",
  game_name_exclude_log: "গেমের নাম লগ বাদ দিন",
  cn: "সিএন",
  local: "স্থানীয়",
  taken: "নেওয়া হয়েছে",
  receiver_bank: "রিসিভার ব্যাংক",
  receiver_bank_acc_no: "রিসিভার ব্যাংক অ্যাকাউন্ট নং",
  receiver_bank_acc_holder: "রিসিভার ব্যাংক এসিসি হোল্ডার",
  add_balance: "ব্যালেন্স যোগ করুন",
  deduct_balance: "ব্যালেন্স কেটে নিন",
  sync_site_content: "সাইটের সামগ্রী সিঙ্ক করুন",
  payment_setting: "পেমেন্ট সেটিং",
  payment_own: "নিজস্ব",
  payment_global: "গ্লোবাল",
  livechat: "লাইভচ্যাট",
  chat_id: "লাইভচ্যাট লাইসেন্স কী",
  chat_provider: "লাইভচ্যাট সরবরাহকারী",
  auto_cycle: "সাইকেল",
  auto_all: "সব",
  completed_amount: "কমপ্লাই অ্যামট",
  website_launched: "ওয়েবসাইট চালু করা হয়েছে",
  total_operators: "মোট অপারেটর",
  today_active: "আজ সক্রিয়",
  new_player_verified_signup: "নতুন প্লেয়ার যাচাই করা হয়েছে/সাইনআপ",
  total_players: "মোট খেলোয়াড়",
  depo_withdrawal_diff: "ডিপো-উইথ ডিফারেন্স",
  claim_count: "দাবি গণনা",
  ggr: "জিজিআর",
  member_balance: "সদস্য ভারসাম্য",
  players: "খেলোয়াড়",
  provider_pt: "সরবরাহকারী পিটি",
  base: "বেস",
  topup_id: "টপআপ আইডি",
  credential: "শংসাপত্র",
  credential_1: "শংসাপত্র 1",
  credential_2: "শংসাপত্র 2",
  credential_3: "শংসাপত্র 3",
  credential_4: "শংসাপত্র 4",
  credential_5: "শংসাপত্র 5",
  credential_6: "শংসাপত্র 6",
  credential_7: "শংসাপত্র 7",
  credential_8: "শংসাপত্র 8",
  credential_9: "শংসাপত্র 9",
  credential_10: "শংসাপত্র 10",
  limit: "সীমা",
  create: "তৈরি করুন",
  hint: "ইঙ্গিত",
  quickSetup: "দ্রুত সেটআপ",
  next: "পরবর্তী",
  setUpTheme: "সেটআপ থিম",
  checkOut: "চেক আউট",
  standardPackage: "স্ট্যান্ডার্ড প্যাকেজ",
  siteName: "সাইটের নাম",
  information: "তথ্য",
  useThisTemplate: "এই টেমপ্লেটটি ব্যবহার করুন",
  summary: "সারসংক্ষেপ",
  createOperatorAccount: "অপারেটর অ্যাকাউন্ট তৈরি করুন",
  operatorId: "অপারেটর আইডি",
  operatorPwd: "অপারেটর পাসওয়ার্ড",
  new_website: "নতুন ওয়েবসাইট",
  operator_information: "অপারেটরের তথ্য",
  bo_link: "বিও লিঙ্ক",
  daily_summary_sms: "দৈনিক সংক্ষিপ্তসার এসএমএস",
  daily_summary_sms_operator: "দৈনিক সংক্ষিপ্তসার এসএমএস অপারেটর",
  daily_summary_sms_operator_detail: "দৈনিক সংক্ষিপ্তসার এসএমএস অপারেটরের বিশদ",
  sms_count: "এসএমএস গণনা",
  provider_winlose_operator_pt: "সরবরাহকারী উইনলস (অপ. পিটি)",
  pt_on: "পিটি অন",
  share_operator: "শেয়ার অপারেটর",
  share_company: "শেয়ার কোম্পানি",
  token_log: "টোকেন লগ",
  template_code: "টেমপ্লেট কোড",
  template_name: "টেমপ্লেটের নাম",
  mini_game: "মিনি গেম",
  max_game_reward: "ম্যাক্স গেম রিওয়ার্ড",
  max_chance_per_day: "প্রতিদিন সর্বোচ্চ সুযোগ",
  is_recurring_chance: "পুনরাবৃত্তি",
  token_request: "টোকেন",
  enabled: "সক্ষম",
  disabled: "অক্ষম",
  unlimited: "সীমাহীন",
  max_chance_unlimited: "ম্যাক্স চান্স পার ডে আনলিমিটেড",
  mini_game_template: "মিনি গেম টেমপ্লেট",
  reward_code: "পুরষ্কার কোড",
  reward_name: "পুরষ্কারের নাম",
  reward_description: "পুরষ্কারের বর্ণনা",
  reward_probability: "পুরষ্কার সম্ভাব্যতা",
  total_game: "টোটাল গেম",
  total_played_mini_game: "মোট খেলা মিনি গেম",
  total_played_mini_game_detail: "মোট খেলা মিনি গেমের বিশদ",
  total_played_mini_game_detail_operator: "মোট খেলা মিনি গেমের বিশদ (অপারেটর)",
  daily_pnl_operator: "ডেইলি পি অ্যান্ড এল (অপারেটর)",
  token: "টোকেন",
  token_1: "টোকেন 1",
  token_2: "টোকেন 2",
  token_3: "টোকেন 3",
  token_4: "টোকেন 4",
  token_5: "টোকেন 5",
  token_6: "টোকেন 6",
  token_7: "টোকেন 7",
  cash_1: "নগদ 1",
  cash_2: "নগদ 2",
  cash_3: "নগদ 3",
  cash_4: "নগদ 4",
  cash_5: "নগদ 5",
  cash_6: "নগদ 6",
  cash_7: "ক্যাশ 7",
  daily_login: "দৈনিক চেক-ইন (দৈনিক লগইন)",
  daily_login_update: "দৈনিক চেক-ইন (দৈনিক লগইন) আপডেট",
  game_result_reward: "গেম রেজাল্ট (পুরষ্কার)",
  current_streak: "কারেন্ট স্ট্রিক",
  login_streak: "লগইন স্ট্রিক",
  total_token: "টোটাল টোকেন",
  total_mini_game_token_used: "মোট মিনি গেম টোকেন ব্যবহৃত",
  total_mini_game_token_used_detail: "মোট মিনি গেম টোকেন ব্যবহৃত বিশদ",
  total_mini_game_token_used_detail_operator: "মোট মিনি গেম টোকেন ব্যবহৃত বিশদ (অপারেটর)",
  total_reward: "মোট পুরষ্কার",
  total_mini_game_reward: "মোট মিনি গেম পুরষ্কার",
  total_mini_game_reward_detail: "মোট মিনি গেম পুরষ্কারের বিশদ",
  total_mini_game_reward_detail_operator: "মোট মিনি গেম পুরষ্কারের বিশদ (অপারেটর)",
  token_balance: "টোকেন ব্যালেন্স",
  free_game_token: "ফ্রি গেম টোকেন",
  bo_url: "ব্যাকঅফিস ইউআরএল",
  copied: "অনুলিপি করা হয়েছে",
  callback: "কলব্যাক",
  api: "এপিআই",
  prefix: "উপসর্গ",
  delimiter: "ডিলিমিটার",
  url_callback_deposit: "কলব্যাক ইউআরএল জমা করুন",
  url_callback_withdrawal: "প্রত্যাহার কলব্যাক ইউআরএল",
  url_callback_affiliate : "এজেন্ট কলব্যাক ইউআরএল",
  url_api_deposit: "ডিপোজিট কলব্যাক ইউআরএল (এপিআই)",
  url_api_withdrawal: "উইথড্রয়াল কলব্যাক ইউআরএল (এপিআই)",
  url_api_balance: "ব্যালেন্স কলব্যাক ইউআরএল (এপিআই)",
  prefix_deposit: "ডিপোজিট প্রিফিক্স",
  prefix_withdrawal: "প্রত্যাহার উপসর্গ",
  prefix_affiliate : "এজেন্ট প্রিফিক্স",
  prefix_delimiter: "ডিলিমিটার প্রিফিক্স",
  merchant: "বণিক",
  app_id: "অ্যাপ আইডি",
  secret_key: "গোপন চাবি",
  deposit_secret_key: "ডিপোজিট সিক্রেট কী",
  withdrawal_secret_key: "প্রত্যাহার গোপন কী",
  partners: "অংশীদার",
  partner_name: "পার্টনার নাম",
  win: "জয়",
  manifest: "মেনিফেস্ট",
  crop: "ফসল",
  cropImage: "ক্রপ ইমেজ",
  api_url: "এপিআই ইউআরএল",
  start_date_time: "শুরুর তারিখের সময়",
  end_date_time: "সমাপ্তির তারিখের সময়",
  authentication_key: "প্রমাণীকরণ কী",
  one_week: "1 সপ্তাহ",
  two_week: "2 সপ্তাহ",
  one_month: "1 মাস",
  two_month: "2 মাস",
  six_month: "6 মাস",
  edit_promotion_end_date: "প্রচার শেষ তারিখ সম্পাদনা করুন",
  android_app_link: "অ্যান্ড্রয়েড অ্যাপ লিঙ্ক",
  add_android_app_link: "অ্যান্ড্রয়েড অ্যাপ লিঙ্ক যুক্ত করুন",
  operator_details: "অপারেটরের বিবরণ",
  bsb: "বিএসবি",
  payid: "পে আইডি",
  cuit: "কিউট",
  merchant_key: "মার্চেন্ট কী",
  aes_key: "এইএস কী",
  paycode: "পেকোড",
  api_key: "এপিআই কী",
  referral: "রেফারেল পুরস্কার",
  minimum_deposit: "ন্যূনতম আমানত",
  minimum_withdrawal: "ন্যূনতম প্রত্যাহার",
  maximum_withdrawal: "সর্বাধিক প্রত্যাহার",
  cpi: "CPI",
  cpi_enrol: "CPI নিবন্ধন",
  interested: "আগ্রহী",
  non_pickup: "কল রিসিভ হয়নি",
  invalid: "অবৈধ",
  cpi_member_list: "CPI সদস্য তালিকা",
  leaderboard: "লিডারবোর্ড",
  capacity: "ক্ষমতা",
  reward_count: "পুরস্কারের সংখ্যা",
  is_settled: "নিষ্পত্তি হয়েছে কিনা",
  settlement_date: "নিষ্পত্তির তারিখ",
  prize: "পুরস্কার",
  count: "সংখ্যা",
  multiplier: "গুণক",
  ranking: "র‌্যাঙ্কিং",
  leaderboard_ranking: "লিডারবোর্ড র‌্যাঙ্কিং",
  joined_date: "যোগদানের তারিখ",
  ready: "প্রস্তুত",
  busy: "ব্যস্ত",
  phone_list: "ফোন তালিকা",
  single: "একক",
  batch: "ব্যাচ",
  cpi_operator_phone_list: "CPI অপারেটর ফোন তালিকা",
  selected: "নির্বাচিত",
  call: "কল",
  private_key: "প্রাইভেট কী",
  public_key: "পাবলিক কী",
  multi_call: "একাধিক কল",
  add_custom: "কাস্টম যোগ করুন",
  custom_list: "কাস্টম তালিকা",
  assignee: "দায়িত্বপ্রাপ্ত ব্যক্তি",
  urgency: "জরুরিতা",
  urgency_1: "কম",
  urgency_2: "মধ্যম",
  urgency_3: "উচ্চ",
  edit_custom: "কাস্টম সম্পাদনা",
  cpi_custom_list: "CPI কাস্টম তালিকা",
  free_coin_signup: "ফ্রি পয়েন্ট (সাইনআপ)",
  free_coin_daily: "ফ্রি পয়েন্ট (দৈনিক)",
  free_coin_min_withdrawal: "ন্যূনতম উত্তোলন (ফ্রি পয়েন্ট)",
  free_coin_per_unit: "ফ্রি পয়েন্ট বিনিময় হার (পয়েন্ট = {currency} 1)",
  adjust_free_balance: "ফ্রি ব্যালান্স সমন্বয় করুন",
  adjust_free_balance_log: "ফ্রি ব্যালান্স লগ",
  signup: "সাইনআপ",
  adjust: "সমন্বয়",
  ai_assistant: "AI সহকারী",
  en_name: "নাম (ইংরেজি)",
  cn_name: "নাম (চীনা)",
  local_name: "নাম (স্থানীয়)",
  img_small: "ছবি (ছোট)",
  img_large: "ছবি (বড়)",
  small_image: "ছোট ছবি",
  large_image: "বড় ছবি",
  forgot_password: "পাসওয়ার্ড ভুলে গেছেন",
  update_password: "পাসওয়ার্ড আপডেট করুন",
  contact: "যোগাযোগ",
  keyss: "কী",
  iv: "IV",
  callback_public_key: "কলব্যাক পাবলিক কী",
  free_game: "ফ্রি গেম",
  version_no: "ভার্সন নম্বর",
  client_id: "ক্লায়েন্ট আইডি",
  symmetric_key: "সিমেট্রিক কী",
  deposit_token: "জমা টোকেন",
  withdrawal_token: "উত্তোলন টোকেন",
  tac_bank: "ওটিপি (ব্যাংক)",
  tac_login: "ওটিপি (লগইন)",
  tac_signup: "ওটিপি (সাইন আপ)",
  tac_signup_aff: "ওটিপি (অ্যাফিলিয়েট সাইন আপ)",
  merchant_name: "ব্যবসায়ীর নাম",
  tele_status: "টেলি স্ট্যাটাস",
  follow_up: "ফলো-আপ",
  call_type: "কলের ধরন",
  on_call_list: "কল তালিকায়",
  inbox_valid_day: "ইনবক্স বৈধ দিনের",
  manual_deposit: "ম্যানুয়াল ডিপোজিট",
  withdrawal_result: "উত্তোলনের ফলাফল",
  widget_id: "উইজেট আইডি",
  property_id: "প্রোপার্টি আইডি",
  referee: "রেফারি পুরস্কার",
  game_result_free_slots: "গেম ফলাফল (ফ্রি স্লট)",
  crypto_address: "ক্রিপ্টো ঠিকানা",
  crypto_network: "ক্রিপ্টো নেটওয়ার্ক",
  crypto: "ক্রিপ্টো",
  exchange_currency: "বিনিময় মুদ্রা",
  base_rate: "বেস রেট",
  white_label: "White Label",
  aggregator: "অ্যাগ্রেগেটর",
  deposit_rate: "ডিপোজিট রেট",
  withdrawal_rate: "উইথড্রয়াল রেট",
  pending_bet_list_wbet: "মুলতুবি বেট তালিকা (WBET)",
  bet_amount: "বেটের পরিমাণ",
  actual_bet_amount: "আসল বেটের পরিমাণ",
  pending_bet_list_others: "মুলতুবি বেট তালিকা (অন্যান্য স্পোর্টসবুক)",
  dob: "জন্ম তারিখ",
  mail_address: "ডাক ঠিকানা",
  crypto_withdrawal: "ক্রিপ্টো উত্তোলন",
  institute_bank_code: "প্রতিষ্ঠানের ব্যাংক কোড",
  pending_bet_list_9w: "মুলতুবি বেট তালিকা (9W)",
  linkage: "লিংকেজ",
  linkage_op: "লিংকেজ অপারেটর",
  member_linkage: "সদস্য লিংকেজ",
  risk_weight: "ঝুঁকি ওজন",
  full_linkage: "পূর্ণ লিংকেজ",
  total_risk_score: "মোট ঝুঁকি স্কোর",
  linkage_value: "লিংকেজ মান",
  source_occurrence_count: "সোর্স উপস্থিতির সংখ্যা",
  source_last_seen_at: "সর্বশেষ দেখা (সোর্স)",
  target_occurrence_count: "টার্গেট উপস্থিতির সংখ্যা",
  target_last_seen_at: "সর্বশেষ দেখা (টার্গেট)",
  member_linkage_detail: "সদস্য লিংকেজ বিস্তারিত",
  merchant_uid: "ব্যবসায়ীর আইডি",
  merchant_no: "ব্যবসায়ীর নম্বর",
  slot_view: "স্লট ভিউ",
  settlement_list_affiliate: "নিষ্পত্তি তালিকা (অ্যাফিলিয়েট)",
  source: "উৎস",
  earning_breakdown: "আয়ের বিশ্লেষণ",
  deposit_bonus: "ডিপোজিট বোনাস",
  winlose_turnover: "জয়/পরাজয়/টার্নওভার",
  cost: "খরচ",
  promotion_voucher: "প্রমোশন ভাউচার",
  voucher_id: "ভুক্তি আইডি",
  voucher_cash: "ভুক্তি ক্যাশ",
  ticketvoucher: "টিকিট ভাউচার",
  ticket_voucher_list_member: "টিকিট ভাউচার তালিকা (সদস্য)",
  ticket_voucher_list: "টিকিট ভাউচার তালিকা",
  pending_review_funds_voucher: "অপেক্ষমাণ ও পর্যালোচনাধীন টিকিট ভাউচার",
  all_pending_ticket_voucher: "সকল অপেক্ষমাণ টিকিট ভাউচার",
  ticket_voucher_detail: "টিকিট ভাউচার বিস্তারিত",
  raise_deposit_ticket_voucher: "ডিপোজিট টিকিট ভাউচার তৈরি",
  raise_deposit_ticket_voucher_gateway: "ডিপোজিট টিকিট ভাউচার গেটওয়ে তৈরি",
  sos: "SOS টপআপ",
  sos_accumulate_deposit: "SOS টপআপ (সঞ্চিত ডিপোজিট)",
  greeting: "অভিবাদন",
  message: "বার্তা",
  get_voucher: "ভাউচার নিন",
  get_message: "বার্তা নিন",
  voucher: "ভাউচার",
  code: "কোড",
  redeemed_by: "দ্বারা রিডিম করা হয়েছে",
  redeemed_by_operator: "দ্বারা রিডিম করা হয়েছে (অপারেটর)",
  redeemed_at: "রিডিমের সময়",
  created_at: "তৈরি হয়েছে",
  redeemed: "রিডিম হয়েছে",
  member_sos_click_log: "সদস্য SOS ক্লিক লগ",
  member_wallet_voucher_log: "সদস্য ওয়ালেট ভাউচার লগ",
  member_voucher_redeemed_log: "সদস্য ভাউচার রিডেম্পশন লগ",
  action_by_operator: "অপারেটর দ্বারা কার্যক্রম",
  redeem_cash: "নগদ রিডিম",
  generate_voucher: "ভাউচার তৈরি",
  url_api_freecredit: "ফ্রি ক্রেডিট কলব্যাক URL",
  prefix_freecredit: "ফ্রি ক্রেডিট প্রিফিক্স",
  free_credit_member: "ফ্রি ক্রেডিট সদস্য",
  free_credit_provider: "ফ্রি ক্রেডিট প্রদানকারী",
  ticket_detail_fcp: "টিকিটের বিস্তারিত (ফ্রি ক্রেডিট প্রদানকারী)",
  ticket_list_processed: "টিকিট তালিকা (প্রক্রিয়াকৃত)",
  mission: "মিশন",
  non_slot_view: "নন স্লট ভিউ",
  banner: "ব্যানার",
  trigger: "ট্রিগার",
  event_type: "ইভেন্ট টাইপ",
  action_type: "অ্যাকশন টাইপ",
  msg_greeting: "অভিবাদন (বার্তা)",
  msg_title: "শিরোনাম (বার্তা)",
  msg_body: "বডি (বার্তা)",
  send_message: "বার্তা পাঠান",
  promo_type: "প্রমো টাইপ",
  repeatable: "পুনরায় করা যাবে",
  rules: "নিয়মাবলী",
  clear_outstanding_log: "বকেয়া লগ পরিষ্কার করুন",
  free_credit_withdrawal_amount: "ফ্রি ক্রেডিট উত্তোলনের পরিমাণ",
  fc_withdrawal_amount: "FC উত্তোলনের পরিমাণ",
  frozen: "ফ্রোজেন",
  transferred: "স্থানান্তরিত",
  voucher_balance: "ভাউচার ব্যালেন্স",
  adjust_voucher_balance: "ভাউচার ব্যালেন্স সমন্বয় করুন",
  free_game_provider: "ফ্রি গেম প্রদানকারী",
  check_free_spin: "ফ্রি স্পিন যাচাই",
  freespin_log: "ফ্রি স্পিন লগ",
  current_round: "বর্তমান রাউন্ড",
  lines: "লাইন",
  expiry_interval_days: "মেয়াদ শেষ হওয়ার ব্যবধান (দিন)",
  assign: "বরাদ্দ করুন",
  game_code: "গেম কোড",
  clear_free_credit: "ফ্রি ক্রেডিট পরিষ্কার করুন",
  deposit_tier: "ডিপোজিট স্তর",
  point: "পয়েন্ট",
  top: "উপরে",
  bottom: "নিচে",
  leaderboard_banner: "লিডারবোর্ড ব্যানার",
  referral_banner: "রেফারেল ব্যানার",
  tp_site: "ট্রাফিক পুল URL",
  current_icon: "বর্তমান আইকন",
  new_icon: "নতুন আইকন",
  voucher_redeemed: "ভাউচার রিডিম করা হয়েছে",
  on_site: "সাইটে",
  exclude_own: "নিজস্ব বাদ দিন",
  voucher_redeemed_detail: "রিডিম করা ভাউচারের বিস্তারিত",
  gamification: "গ্যামিফিকেশন",
  reward_rain: "Reward Rain",
  total_claimed_amount: "মোট দাবি করা পরিমাণ",
  min_amount: "ন্যূনতম পরিমাণ",
  max_amount: "সর্বোচ্চ পরিমাণ",
  reward_rain_session: "Reward Rain সেশন",
  reward_rain_session_claim: "Reward Rain সেশন দাবি",
  reward_amount: "পুরস্কারের পরিমাণ",
  cta: "CTA",
  api_email: "API ইমেইল",
  api_password: "API পাসওয়ার্ড",
  url_callback_voucher: "ভাউচার কলব্যাক URL",
  prefix_voucher: "ভাউচার প্রিফিক্স",
  slide_show: "স্লাইড শো",
  ewallet_withdrawal: "ই-ওয়ালেট উত্তোলন",
  news: "সংবাদ",
  slug: "স্লাগ",
  preview_body: "কনটেন্ট প্রিভিউ",
  full_body: "সম্পূর্ণ কনটেন্ট",
  normal: "স্বাভাবিক",
  free_balance: "ফ্রি ব্যালেন্স",
  schema: "স্কিমা",

  tt_pixel_id: "TT পিক্সেল আইডি",
  tt_token: "TT টোকেন",

  free_spin_bulk_issue : "ফ্রি স্পিন (বাল্ক ইস্যু)",
}